import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const portfolioMgmtFile = RepositoryFactory.get("portfolioMgmtFile");
export default {
    getportfolio({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await portfolioMgmtFile.getportfolio(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addportfolio({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await portfolioMgmtFile.addportfolio(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
     editportfolio({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await portfolioMgmtFile.editportfolio(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    deleteportfolio({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await portfolioMgmtFile.deleteportfolio(payload)
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}